import React, { useState } from 'react';

const WaitlistSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setStatus('error');
      setMessage('Please enter a valid email address.');
      return;
    }

    try {
      const response = await fetch(`${BACKEND_URL}/api/waitlist`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setMessage(data.message || 'You\'re on the list! We\'ll email you when the CompanionCab app launches.');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(data.detail || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Network error. Please check your connection and try again.');
    }
  };

  return (
    <section className="waitlist-section" id="waitlist">
      <div className="waitlist-container">
        <div className="waitlist-content">
          <div className="waitlist-header">
            <span className="beta-badge">🚀 App Coming Soon</span>
            <h2>Get the CompanionCab App First</h2>
            <p>Join our waitlist to be notified when the CompanionCab mobile app launches. Book rides, track your companion, and manage trips - all from your phone.</p>
          </div>

          {status === 'success' ? (
            <div className="waitlist-success">
              <div className="success-icon">✓</div>
              <h3>You're on the list!</h3>
              <p>{message}</p>
              <button 
                className="btn-secondary-waitlist" 
                onClick={() => setStatus('idle')}
              >
                Add another email
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="waitlist-form">
              <div className="waitlist-inputs">
                <div className="input-wrapper">
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="waitlist-input"
                  />
                </div>
                <button 
                  type="submit" 
                  className="waitlist-submit-btn"
                  disabled={status === 'loading' || !email}
                >
                  {status === 'loading' ? (
                    <span>Joining...</span>
                  ) : (
                    <span>Notify Me</span>
                  )}
                </button>
              </div>
              
              {status === 'error' && (
                <div className="waitlist-error">
                  <span>⚠️</span> {message}
                </div>
              )}

              <p className="waitlist-privacy">
                🔒 No spam, ever. Just one email when we launch.
              </p>
            </form>
          )}

          <div className="waitlist-features">
            <div className="waitlist-feature">
              <span className="feature-icon">📱</span>
              <span>App launch notification</span>
            </div>
            <div className="waitlist-feature">
              <span className="feature-icon">🎁</span>
              <span>Exclusive launch discount</span>
            </div>
            <div className="waitlist-feature">
              <span className="feature-icon">💖</span>
              <span>Priority booking access</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WaitlistSection;
